import gql from 'graphql-tag';

export default gql`
    mutation UpdateSplitLoad($loadId: Int, $isSplit: Boolean) {
        updateSplitLoad(loadId: $loadId, isSplit: $isSplit) {
            errors
        }
    }
`;
